<template>
    <div class="wrapper">
        <div class="classifys flex align-center justify-between">
            <div class="flex align-center">
                <router-link class="classify " :to="`/organization/members/list?${share_id ? `share_id=${share_id}` : ''}`">单位会员</router-link>
                <router-link class="classify active" :to="`/organization/members/slist?${share_id ? `share_id=${share_id}` : ''}`">个人会员</router-link>
            </div>
            <router-link  to="/organization/members/sdraft"><el-button>草稿箱</el-button></router-link>
        </div>
        <div class="padding-sm bg-white margin-bottom-sm flex align-center justify-between member-set">
            <div @click="addMember">会员录入</div>
<!--            <el-link :href="baseURL + 'Admin/Personal/exportUserTemplate?mid=' + user.mid + '&sign=' + user.sign"-->
<!--                     :underline="false">-->
<!--                <div>模版下载</div>-->
<!--            </el-link>-->
            <div @click="downTemplate">模版下载</div>

            <el-dropdown placement="bottom">
              <span class="el-dropdown-link">
                会员导入<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <el-upload
                            :action="baseURL + 'Admin/Personal/importUser_optimized'"
                            :data="fileData"
                            :on-success="(response)=>{return handleAvatarSuccess(response,1)}"
                            :show-file-list="false"
                        >新增会员导入
                        </el-upload>
                    </el-dropdown-item>
                    <el-tooltip class="item" effect="dark" content="更新会员信息，需要先导出会员信息" placement="right">
                        <el-dropdown-item>
                            <el-upload
                                :action="baseURL + 'Admin/Personal/importUpdateUser_optimized'"
                                :data="fileData"
                                :on-success="(response)=>{return handleAvatarSuccess(response,11)}"
                                :show-file-list="false">修改会员导入
                            </el-upload>
                        </el-dropdown-item>
                    </el-tooltip>

                </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown placement="bottom">
              <span class="el-dropdown-link">
                会员导出<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <el-link
                            :href="baseURL + 'Admin/Personal/exportUser?mid=' + user.mid + '&sign=' + user.sign + '&rankId='+level+'&costStatus='+fee+'&endTimeType='+time+'&isLocking='+lock+'&searchKey=' + keyWord+'&select_fenhui_id=' + organiz_id+'&start_time=' + start_time+'&end_time=' + end_time"
                            :underline="false">
                            <div>会员信息导出</div>
                        </el-link>
                    </el-dropdown-item>
                    <el-tooltip class="item" effect="dark" content="用于更新会员信息" placement="right">
                        <el-dropdown-item>
                            <el-link
                                :href="baseURL + 'Admin/Personal/exportUserUpdateTemplate?mid=' + user.mid + '&sign=' + user.sign + '&rankId='+level+'&costStatus='+fee+'&endTimeType='+time+'&isLocking='+lock+'&searchKey=' + keyWord+'&select_fenhui_id=' + organiz_id+'&start_time=' + start_time+'&end_time=' + end_time"
                                :underline="false">
                                <div>更新信息导出</div>
                            </el-link>
                        </el-dropdown-item>
                    </el-tooltip>
                </el-dropdown-menu>
            </el-dropdown>


            <el-link
                :href="baseURL + 'admin/excel/userCertExportExcel?user_type=2&mid=' + user.mid + '&sign=' + user.sign + '&rank_id='+level+'&status='+fee+'&time='+time+'&is_locking='+lock+'&keyword=' + keyWord+'&select_fenhui_id=' + organiz_id+'&start_time=' + start_time+'&end_time=' + end_time"
                :underline="false">
                <div>证书信息导出</div>
            </el-link>
            <el-upload
                :action="baseURL + 'admin/excel/userCertImportExcel'"
                :data="fileData"
                :on-success="(response)=>{return handleAvatarSuccess(response,0)}"
                :show-file-list="false"
            >证书信息导入
            </el-upload>
            <router-link to="/organization/setup/invitation"><div>邀请会员</div></router-link>
        </div>
        <div class="padding-sm bg-white flex-sub">
            <div>
                <div class="flex align-center justify-between margin-bottom-sm">
                    <el-select v-model="organiz_id" class="margin-right-xs" clearable placeholder="请选择所属协会">
                        <el-option
                            v-for="item in organizList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="level" class="margin-right-xs" clearable placeholder="请选择会员等级">
                        <el-option
                            v-for="item in levelList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="fee" class="margin-right-xs" clearable placeholder="请选择缴费状态">
                        <el-option
                            v-for="item in feeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
<!--                    <el-select v-model="time" class="margin-right-xs" clearable placeholder="请选择到期时间">-->
<!--                        <el-option-->
<!--                            v-for="item in endTime"-->
<!--                            :key="item.value"-->
<!--                            :label="item.label"-->
<!--                            :value="item.value">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
                    <el-select v-model="lock" class="margin-right-xs" clearable placeholder="请选择锁定状态">
                        <el-option
                            v-for="item in lockList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-date-picker v-model="start_time" class="margin-right-xs" type="date" value-format="yyyy-MM-dd" placeholder="到期开始日期"></el-date-picker>
                    <el-date-picker v-model="end_time"  type="date" value-format="yyyy-MM-dd" placeholder="到期截止日期"></el-date-picker>

                </div>
                <div class="flex align-center justify-between margin-bottom-sm list-search">
                    <el-input
                        v-model="keyWord"
                        placeholder="请输入会员姓名/联系人姓名/联系电话"
                    ></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                    <el-button class="blue-btn" @click="reset">重置</el-button>
                    <el-button  type="primary" @click="delAll">批量删除</el-button>
                </div>
            </div>
            <div class="ship-list">
                <el-table
                    ref="multipleTable"
                    v-loading="loading"
                    :data="lists" border
                    header-row-class-name="table-header"
                    @sort-change="sortChange"
                    row-key="user_id"
                    style="width: 100%; border-radius: 10px"
                    @selection-change="handleSelectionChange">
                    <el-table-column
                        label="全选"
                        reserve-selection
                        type="selection"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        label="序号"
                        prop="index"  sortable="custom"
                        width="75">
                        <template slot-scope="scope">
                            <div class="table-name">
                              {{ scope.$index + 1 + (page-1)*15 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="会员姓名" prop="name" width="100px">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.name }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="所属协会" prop="company" width="150px">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.org_name || user.morgname }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="工作单位" prop="company" width="150px">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.company }}</div>
                        </template>
                    </el-table-column>
                    <!--            <el-table-column label="法人" prop="name">-->
                    <!--              <template slot-scope="scope">-->
                    <!--                <div class="table-name"> {{scope.row.morgname}}</div>-->
                    <!--              </template>-->
                    <!--            </el-table-column>-->

                    <el-table-column label="手机号" prop="phone" width="120px">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.phone }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="会员等级" prop="rank_name">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.rank_name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="缴费状态" prop="status">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.status === 1 ? '已缴费' : '未缴费' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="积分" prop="integral">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.integral }}分
                            </div>
                        </template>
                    </el-table-column>
<!--                    <el-table-column label="到期时间" prop="end_time" width="110px">-->
<!--                        <template slot-scope="scope">-->
<!--                            <div class="table-name">-->
<!--                                {{ scope.row.end_time | setTime }}-->
<!--                            </div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column label="操作" width="130px">
                        <template slot-scope="scope">
                            <div class="flex justify-center  align-center">
                                <el-link class="table-operate" @click="itemDetail(scope.row.user_id)">查看</el-link>
                                <el-link class="table-operate" @click="itemCertificate(scope.row.user_id)">证书</el-link>
                                <el-link class="table-operate" @click="itemExport(scope.row.user_id)"  v-if="isZch">导出</el-link>
                            </div>
                            <div class="flex justify-center  align-center">
                                <el-link :class="{'active':scope.row.is_locking === 0}" class="table-operate "
                                         @click="itemSet(scope.row.user_id,scope.row.is_locking)">
                                    {{ scope.row.is_locking === 0 ? '锁定' : '解锁' }}
                                </el-link>
                                <el-link :class="{'active':scope.row.is_out === 0}" class="table-operate "
                                         @click="itemSetOut(scope.row.user_id,scope.row.is_out)">
                                    {{ scope.row.is_out === 0 ? '退会' : '入会' }}
                                </el-link>
                                <el-link class="table-operate active" @click="itemDel(scope.row.user_id)">删除</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top"
                layout="prev, pager, next, jumper"
                @current-change="userList">
            </el-pagination>
        </div>
        <import-down-dialog :dialog-visible="importDownDialog" :type="1" @watchState="watchDownState"></import-down-dialog>
        <import-state-dialog :dialog-visible="importStateDialog" :type="cur_type" :step="cur_step" :file-path="cur_file_path" @watchState="watchState"></import-state-dialog>
    </div>
</template>

<script>
import {endTime, feeList, lockList} from "@/utils/const";
import {
    getDownTempState,
    getRankList,
    memberDel,
    memberDocExport,
    memberSet,
    memberSetOut,
    membersPersonalList
} from "@/api/organiz";
import {zhDate} from "@/utils/utils";
import {baseURL} from "@/config";
import {getfenhuiList} from "@/api/login";
import {getUser} from "@/utils/utils";
import ImportDownDialog from "@/components/ImportDownDialog";
import ImportStateDialog from "@/components/ImportStateDialog";
import {isZch} from "@/utils/rules";

export default {
    name: "members",
    data() {
        return {
            share_id:'',
            baseURL: baseURL,
            levelList: [{
                id: 0,
                name: "全部"
            }],
            organizList: [{
                id: -1,
                name: "全部"
            },{
                id: 0,
                name: getUser().morgname
            }],
            feeList: feeList,
            endTime: endTime,
            lockList: lockList,
            organiz_id: '',
            level: '',
            fee: '',
            time: '',
            start_time: '',
            end_time: '',
            lock: '',
            order: 1,
            keyWord: '',
            lists: [],
            page: 1,
            limit: 15,
            total: 0,
            loading: false,
            importDownDialog: false,
            importDown_state:0,
            cur_type:2,
            cur_step:'',
            cur_file_path:'',
            importStateDialog: false,

            select_lists:[]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                mid: this.user.mid,
                sign: this.user.sign,
                op_type: 1,
            }
        },
        isZch() {
            return isZch(this.user.mid)
        },
    },
    created() {
        this.$emit('setIndex', [3, 0], '会员管理')
        this.getParams()
        this.getDownTempState()
        this.userList()
        // 级别管理下拉列表
        this.getRankList()
    },
    components: {ImportStateDialog, ImportDownDialog},
    methods: {
        getParams() {
            if (this.$route.query.fee) this.fee = Number(this.$route.query.fee)
            this.share_id = this.$route.query.share_id
        },
        //  上传成功
        handleAvatarSuccess(file,type) {
            if (file.status === 200) {
                // this.$message.success(file.msg)
                // this.userList()
                if (type) {
                    this.cur_type = type
                    this.cur_step = file.data.step
                    this.cur_file_path = file.data.url
                    this.importStateDialog = true;
                } else {
                    this.$message.success(file.msg)
                    this.userList()
                }
            } else {
                this.$message.error(file.msg)
            }
        },
        watchState(data) {
            if (data) {
                this.userList()
            } else {
                this.importStateDialog = false
            }
        },
        async getDownTempState(){
            let _data = await getDownTempState(2)
            this.importDown_state = _data.data.is_alert
        },
        watchDownState(data) {
            if (data) {
                this.getDownTempState()
            }
            this.importDownDialog = false
        },
        downTemplate() {
            if (this.importDown_state) {
                this.importDownDialog = true
            } else {
                window.open(this.baseURL + 'Admin/Personal/exportUserTemplate?mid=' + this.user.mid + '&sign=' + this.user.sign)
            }
        },
        //  邀请会员
        toInvitation() {
            this.$router.push('/organization/setup/invitation')
        },
        //  会员录入
        addMember() {
            this.$router.push('/organization/members/info/0/2')
        },
        itemDetail(id) {
            this.$router.push(`/organization/members/info/${id}/2` )
        },
        itemCertificate(id) {
            this.$router.push('/organization/members/certificate/' + id)
        },
        itemSet(id, state) {
            this.$confirm('此操作将' + (state === 0 ? '锁定' : '解锁') + '该会员, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureSet(id, state)
            })
        },
        async sureSet(id, state) {
            let _state = await memberSet(id, state === 0 ? 1 : 0)
            if (_state.status === 200) {
                this.$message.success(_state.msg)
                await this.userList()
            }
        },
        itemSetOut(id, state) {
            this.$confirm('此操作将修改该会员状态为' + (state === 0 ? '退会' : '入会') + ', 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.memberSetOut(id, state)
            })
        },
        async memberSetOut(id, state) {
            let _state = await memberSetOut(id, state === 0 ? 1 : 0)
            if (_state.status === 200) {
                this.$message.success(_state.msg)
                await this.userList()
            }
        },
        itemDel(id) {
            this.$confirm('此操作将删除该会员, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(id)
            })
        },
        async sureDelete(id) {
            let _state = await memberDel(id)
            if (_state.status === 200) {
                this.$message.success(_state.msg)
                await this.userList()
                this.select_lists = []
                this.$refs.multipleTable.clearSelection()
            }
        },
        delAll() {
            if (this.select_lists.length === 0) return this.$message.error('请选择要删除的项')
            let _cur_ids = this.select_lists
                .map((item) => {
                    return item.user_id
                })
                .join(",")
            this.$confirm('此操作将删除选中的会员, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(_cur_ids)
            })
        },
        handleSelectionChange(val) {
            this.select_lists = val
        },
        reset() {
            this.organiz_id = ''
            this.level = ''
            this.fee = ''
            this.time = ''
            this.start_time = ''
            this.end_time = ''
            this.lock = ''
            this.keyWord = ''
            this.page = 1
            this.userList()
        },
        search() {
            this.page = 1
            this.userList()
        },
        // 获取等级
        async userList() {
          let _list = await membersPersonalList(this.page, this.limit,this.start_time,this.end_time,
              this.keyWord, this.level, this.fee, this.time, this.lock,this.order,this.share_id,
              this.organiz_id=== -1 ? -1 : this.organiz_id)
          if(_list.status === 200){
            this.lists = _list.data
            this.total = _list.count
          }else {
              this.lists = [];
              this.total =0;
          }
        },
        //  获取等级列表
        async getRankList() {
            let _list = await getRankList(1,2)
            this.levelList = [...this.levelList, ..._list.data]
            let _data = await getfenhuiList(this.user.mid)
            this.organizList = [...this.organizList, ..._data.data]
        },
        sortChange({prop, order}) {
            if (prop === 'index') {
                this.order = order === 'ascending' ? 2 : 1
            }
            this.userList()
        },
        async itemExport(id) {
            let _data = await memberDocExport(id)
            if (_data.status === 200) {
                window.open(_data.data.url)
            } else {
                this.$message.error(_data.msg)
            }
        },
    },
    filters: {
        setTime(val) {
            return Number(val) ? zhDate(new Date(val * 1000)) : '--'
        }
    },
    watch: {
        $route: function () {
            this.getParams()
            this.userList()
        }
    },
}
</script>

<style lang="scss" scoped>
.wrapper {
    .min-height {
        min-height: 930px;
    }

    .classifys {
        margin-bottom: 20px;
        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            border-radius: 6px 0  0 6px;
            color: #ffb400;
            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 0 6px 6px 0;

            }
        }
    }

    .member-set {
        div {
            width: 130px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            background-color: #f3f7fb;
            border-radius: 10px;
            border: solid 1px #dae0e6;
            font-size: 18px;
            cursor: pointer;
            font-weight: normal;

            &:hover {
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#0a2240, #0a2240);
                background-blend-mode: normal, normal;
                color: #fff;
            }
        }
    }

    .list-search {
        .el-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background: #0a2240;
            border: 0;
            font-size: 16px;
        }
    }

    .table-name {
        font-size: 14px;
        color: #333333;
        text-align: center;

        &.gray {
            color: #999999;
        }
    }

    .table-operate {
        color: #ffa11a;
        margin: 0 3px;

        &.active {
            color: #e4396c;
        }

    }
}
</style>
